import { createContext, useContext, useState } from 'react';

const FileSelectionContext = createContext();

export const FileSelectionProvider = ({ children }) => {
  const [fileSelected, setFileSelected] = useState(null);

  const updateSelectedFile = (fileId, files) => {
    const file = files.find((f) => f.job_id === fileId) || null;
    setFileSelected(file);
  };
  
  return (
    <FileSelectionContext.Provider value={{ fileSelected, updateSelectedFile }}>
      {children}
    </FileSelectionContext.Provider>
  );
};

export const useFileSelection = () => useContext(FileSelectionContext);